<template>
	<div>
        <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons" v-if="filterHeading !== ''">
            {{filterHeading}}
        </div>
        <input autocomplete="off" type="text" @input="updateValue($event)" ref="input">
    </div>
</template>

<script>
	import DateInput from 'components/form/control/DateInput.vue';

    export default {
        name: 'InputFilter',
        components: {DateInput},
        props: {
        	filterHeading: {
        		type: String,
        		default: ''
        	},
        	pound: {
        		type: Boolean,
        		default: false
        	},
        	date: {
        		type: Boolean,
        		default: false
        	},
        	id: {
        		type: Number,
        		default: 0
        	},
            name: {
                type: String,
                default: ''
            },
            // Callback
            update: {},
        },
        methods: {
            updateValue(event) {
                this.update({key: this.name, value: event.target.value});
            },
            reset() {
                this.update({key: this.name, value: null});
                this.$refs.input.value = null;
            },
        }
    }

</script>


// WEBPACK FOOTER //
// InputFilter.vue?161e3b4e